<template>
  <div class="v1-style-bottom" :class="{ mobile: isMobile ? true : false }" @click="handleClick">
    <div
      class="menu-box"
      v-if="!isMobile"
      :style="{
        height: $h_Ratio(menuStyle.height, $store) + 'px',
        minWidth: $w_Ratio(menuStyle.width, $store) + 'px',
      }"
      :class="{ 'menu-down': !isOpenBottomMenu }"
    >
      <div
        class="menu-list"
        :style="{
          top: $h_Ratio(-50, $store) + '%',
        }"
      >
        <div
          class="menu-item"
          :style="getMenuItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <!-- 按钮背景 -->
            <img :src="BottomImg" alt="" class="bk" />
            <!-- 图标 -->
            <img :src="item.IconPath" alt="" class="img" />
          </div>
          <!-- 文字
            -->
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
    <div class="toggle-open-btn" :style="getToggleOpenBtn()" @click="toggleOpen">
      <i :class="isOpenBottomMenu ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>

    <!-- 手机端 -->
    <div class="mobile-menu" v-if="isMobile">
      <div class="icon" @click="isShow = !isShow">
        <img src="@/assets/img/mobile/menu.png" alt="" />
      </div>
      <div class="scene" :style="{ left: isShow ? '0%' : '150px' }">
        <div
          class="menu-item"
          :style="getMenuItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <!-- <img
              :src="item.IconActivePath"
              v-if="item.id === $store.state.ProjectInfo.CurrentScene.id"
              alt=""
            /> -->

            <img :src="item.IconPath" alt="" class="pic" />
          </div>
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
          >
            <!--   -->
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'V1StyleBottom',
  components: {},
  props: {
    Configuration: Object,
    SceneryList: Array,
  },
  data() {
    return {
      isShow: false,
      isOpenBottomMenu: true,
      style: {},
      menuStyle: {
        height: 85,
        width: 700,
      },
      BottomImg: require('../../../../public/img/styles/menusIcons/bottomIcon/V1bottom.png'),
      menuItemStyle: {},
      backgroundDefault: null, // 临时存储原来背景
    };
  },
  watch: {
    SceneryList: {
      deep: true,
      handler: function (newVal) {
        this.setMenuShowLength(newVal);
      },
    },
  },
  created() {
    this.setMenuShowLength(this.SceneryList);
    // console.log(this.Configuration.propertyData);
    if (this.Configuration.propertyData.menuStyle) {
      this.menuStyle = this.$_.cloneDeep(this.Configuration.propertyData.menuStyle.value);
    }
  },
  mounted() {
    this.SceneryList.sort((a, b) => {
      return a.sceneSortIndex - b.sceneSortIndex;
    });
    this.backgroundDefault = this.$store.state.ProjectInfo.Background;
  },
  methods: {
    ...mapMutations(['set_CurrentScene', 'set_ProjectBackground', 'set_CurrentConfigration']),
    setMenuShowLength(SceneryList) {
      if (SceneryList.length > 4) {
        this.menuStyle.width = 700 + (SceneryList.length - 4) * 95;
      }
      if (this.Configuration.propertyData.menuStyle) {
        this.$store.commit('set_ProjectStylePropertyData', {
          key: 'menuStyle',
          value: this.$_.cloneDeep(this.menuStyle),
        });
      }
    },
    toggleOpen() {
      this.isOpenBottomMenu = !this.isOpenBottomMenu;
    },
    handleSwitchScene(item) {
      this.set_CurrentScene(item.id);
      if (item.isChangeBk === true) {
        if (item.Background.componentTitle === '图片背景') {
          let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
          if (
            backgroundDefault == null ||
            backgroundDefault == 'null' ||
            backgroundDefault == undefined ||
            backgroundDefault == 'undefined'
          ) {
            this.set_ProjectBackground(this.backgroundDefault);
            this.set_CurrentConfigration(this.backgroundDefault);
          } else {
            this.set_ProjectBackground(backgroundDefault);
            this.set_CurrentConfigration(backgroundDefault);
          }
        } else {
          this.set_ProjectBackground(item.Background);
          this.set_CurrentConfigration(item.Background);
        }
      } else {
        let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
        if (
          backgroundDefault == null ||
          backgroundDefault == 'null' ||
          backgroundDefault == undefined ||
          backgroundDefault == 'undefined'
        ) {
          this.set_ProjectBackground(this.backgroundDefault);
          this.set_CurrentConfigration(this.backgroundDefault);
        } else {
          this.set_ProjectBackground(backgroundDefault);
          this.set_CurrentConfigration(backgroundDefault);
        }
      }
    },
    getMenuStyle() {
      return {
        height: this.$h_Ratio(this.menuStyle.height, this.$store) + 'px',
        minWidth: this.$w_Ratio(this.menuStyle.width, this.$store) + 'px',
      };
    },
    getMenuItemStyle() {
      return {
        height: this.$w_Ratio(90, this.$store) + 'px',
        width: this.$w_Ratio(120, this.$store) + 'px',
        fontSize: '12px',
        margin: `0 ${this.$w_Ratio(1, this.$store)}px`,
      };
    },
    getToggleOpenBtn() {
      return {
        height: this.$h_Ratio(13, this.$store) + 'px',
        width: this.$w_Ratio(150, this.$store) + 'px',
        fontSize: this.$w_Ratio(14, this.$store) + 'px',
      };
    },
    getMargin(a, b) {
      return {
        margin: `${this.$w_Ratio(a, this.$store)}px 
               ${this.$w_Ratio(b, this.$store)}px`,
        height: this.$h_Ratio(2, this.$store) + 'px',
      };
    },

    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      SceneryList: state => state.ProjectInfo.SceneryList,
    }),
    newSceneryList() {
      return this.SceneryList.sort((a, b) => {
        return a.sceneSortIndex - b.sceneSortIndex;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
img {
  height: 100%;
  width: 100%;
}
.v1-style-bottom {
  z-index: 99;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 100%;
  transition: all 0.3 linear;
  color: white;
  background-color: rgb(179, 200, 245);
  .menu-box {
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translateX(-50%);
    transition: transform 0.3s linear;
    .bottom-bg {
      width: 100%;
      height: 90%;
      position: absolute;
      bottom: 0;
    }
    .menu-list {
      position: absolute;
      display: flex;
      top: -40%;
      left: 50%;
      transform: translateX(-50%);
      align-items: center;
      justify-content: center;
      .menu-item {
        transition: all 0.3s ease-out;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .menu-item-icon-name {
          text-align: center;
          white-space: nowrap;
        }
        .menu-item-icon-ct {
          width: 100%;
          height: 100%;
          transition: all 0.3s ease-out;
          margin-bottom: 2px;
          position: relative;
          top: 0;
          .bk {
            position: absolute;
            z-index: 1;
            bottom: -18px;
            width: 100%;
            height: 74%;
            transition: all 0.3s ease-out;
          }
          img.img {
            position: relative;
            z-index: 2;
            width: 70%;
            height: 74%;
            margin: auto;
            transition: all 0.3s ease-out;
          }
          opacity: 0.8;
        }
        .active {
          opacity: 1;
          top: -6px !important;
          width: 104% !important;
          height: 104% !important;
        }
        &:hover .menu-item-icon-ct {
          width: 104% !important;
          height: 104% !important;
        }
      }
    }
  }
  .menu-down {
    transform: translate(-50%, 200%);
  }
  .toggle-open-btn {
    cursor: pointer;
    width: 150px;
    height: 13px;
    font-size: 14px;
    background-color: #212631;
    border-radius: 20px 20px 0 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-weight: 700;
    &:hover {
      color: rgb(35, 130, 255);
    }
  }
}
// 手机端
.mobile-menu {
  position: absolute;
  .icon {
    cursor: pointer;
    width: 30px;
  }
  .scene {
    position: absolute;
    left: -50px;
    top: 50px;
    background: url('../../../assets/img/mobile/style5/menu_item_bk.png') no-repeat;
    background-size: 100% 100%;
    transition: all 0.3s ease-in-out;
    transform: translate(-50%, 0);
    .menu-item {
      cursor: pointer;
      flex-shrink: 0;
      transition: all 0.3s ease-out;

      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;

      .menu-item-icon-name {
        text-align: center;

        white-space: nowrap;
        // margin-right: 8px;
      }

      .menu-item-icon-ct {
        width: 90%;
        height: 56%;
        transition: all 0.3s ease-out;
        margin-bottom: 2px;
        position: relative;
        img.bk {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
        }
        img.pic {
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 2;
        }

        opacity: 0.8;
      }

      .active {
        width: 110%;
        height: 68%;
        opacity: 1;
      }

      &:hover .menu-item-icon-ct {
        width: 110%;
        height: 68%;
      }
    }
  }
}
</style>
